import { createSelector } from 'reselect'

export const getIsGroupPage = createSelector(
  (state) => state && state.groups && state.groups.isGroupPage ? state.groups.isGroupPage : false,
  (isGroupPage) => isGroupPage
)
